import { generatePath } from 'react-router';

import { InternalPageId } from '#/service/constants/menu';

// switch to something like this later:
// https://github.com/adamziel/react-router-named-routes#react-router-40
export enum Path {
  Channels = '/channels',
  Login = '/login',
  Registration = '/registration',
  ForgotPassword = '/forgotPassword',
  History = '/history',
  UpdatePassword = '/updatePassword',
  Readme = '/readme/:urlName',
  Settings = '/settings/:settingId',
  SettingsRoot = '/settings',
  Search = '/search',
  Favorites = '/favorites',
  Subscribe = '/subscribe',
  Page = '/page/:pageId',
  Details = '/details/:pageId/:resourceType/:resourceId/*',
  Playback = '/playback/:resourceType/:resourceId',
  External = '/external/:paymentType/:result',
  AlternativePurchase = '/alternativePurchase',
  Home = '/',
  TveSecondScreenLogin = '/tve',
  SecondScreenLogin = '/tv',
  GiftRedeem = '/gift/redeem',
  GiftPurchase = '/gift/purchase',
  Cancel = '/cancel',
}

export const destinationRoutes: Record<InternalPageId, string | undefined> = {
  [InternalPageId.Register]: Path.Registration,
  [InternalPageId.WatchHistory]: Path.History,
  [InternalPageId.Search]: Path.Search,
  [InternalPageId.Favorites]: Path.Favorites,
  [InternalPageId.SubscriptionCancel]: Path.Cancel,
  [InternalPageId.ProgramList]: Path.Channels,
  [InternalPageId.Settings]: Path.SettingsRoot,
  [InternalPageId.More]: Path.SettingsRoot,
  [InternalPageId.ForgotPassword]: Path.ForgotPassword,
  [InternalPageId.TermsAndConditions]: generatePath(Path.Readme, {
    urlName: 'terms',
  }),
  // these page IDs don't have a corresponding route
  [InternalPageId.Login]: undefined,
  [InternalPageId.Iap]: undefined,
};
